import React from "react";
import Slider from "react-slick";
import "./Slider.css";
import "./Slider-theme.css";

function Slide({slideData}) {
  const settings = {
    dots: false,
    autoplaySpeed: 6000,
    autoplay: true,
    infinite: true,
    speed: 700,
    lazyLoad: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div >
      <Slider {...settings}>
        {
          slideData.map((info, index) => (
            <div key={index} className="slide__container  w-full">
                        <div className="slide-content w-full md:h-full overflow-hidden" >
                            <img className='w-full h-full object-contain' src={info.bgImg} alt="" />
                        </div>
                    </div>
          ))
        }
        
      </Slider>
    
    </div>
  );
}

export default Slide;